// extracted by mini-css-extract-plugin
export default {"menuBtn":"HamburgerMenu_menuBtn__tR4qz","menuBtnBurger":"HamburgerMenu_menuBtnBurger__h2JOz","open":"HamburgerMenu_open__L8ZVJ"};